import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { useEffect } from 'react'
import { showBrowserWarning } from './utils/browserUtils'
import ErrorBoundary from './components/base/ErrorBoundary'
import { AuthProvider } from './contexts/AuthContext'
import AIAssistant from './components/feature/AIAssistant'

function App() {
  useEffect(() => {
    console.log('🎨 [App] 组件已挂载，开始初始化...');
    // 在应用启动时检测浏览器问题
    showBrowserWarning();
    console.log('✅ [App] 浏览器检测完成');
  }, []);

  console.log('🎨 [App] 开始渲染组件树...');
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <AIAssistant />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App